import React, { Component } from 'react';
import { connect } from 'react-redux';
import authUtils from '../../auth/utils';
import { fetchTeacher, createTeacher, updateTeacher, loadNoTeacherUsers, createTeacherFromExistingUser } from './actions';
import TeacherSettingsForm from './SettingsForm';
import FromExistingForm from './FromExistingForm';
import { withTranslation } from 'react-i18next';
import { getActiveLanguage } from '../../languages/reducer';
import { Panel } from 'react-bootstrap';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleTeacherSettingsSubmit = this.handleTeacherSettingsSubmit.bind(this);
		this.changeFromExisting = this.changeFromExisting.bind(this);
		this.onSelectExistingUser = this.onSelectExistingUser.bind(this);
		this.state = {
			fromExisting: false
		};
	}
	componentDidMount() {
		const { match, fetchTeacher, franchiseeId, loadNoTeacherUsers } = this.props;
		loadNoTeacherUsers(franchiseeId);

		const teacherId = match.params.teacherId;
		if (teacherId) {
			fetchTeacher(teacherId);
		}
	}

	handleTeacherSettingsSubmit(values) {
		const { teacher, updateTeacher, createTeacher, createTeacherFromExistingUser, history, franchiseeId } = this.props;
		if (this.state.fromExisting && this.state.selectedUserId > 0) {
			const onSuccessEvent = () => {
				this.props.loadNoTeacherUsers(franchiseeId);
				this.setState({ fromExisting: false });
			};
			createTeacherFromExistingUser(this.state.selectedUserId, franchiseeId, history, onSuccessEvent);
		}
		else {
			Object.assign(values, { franchiseeId });
			if (teacher) {
				updateTeacher(teacher.id, values);
			} else {
				createTeacher(values, franchiseeId, history);
			}
		}
	}

	changeFromExisting(event, fromExisting) {
		this.setState({ fromExisting });
		if (!fromExisting) {
			this.setState({ selectedUserId: 0 });
		}
	}

	onSelectExistingUser(event, selectedUserId) {
		this.setState({ selectedUserId });
	}

	render() {
		const { match, teacher, isReadonly, franchiseeId, noTeacherUsers, noTeacherUsersByFranchisee, lang, t } = this.props;
		let initialValues = teacher;
		if (this.state.selectedUserId > 0) {
			initialValues = noTeacherUsers[this.state.selectedUserId];
		}
		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				{!match.params.teacherId &&
					<FromExistingForm initialValues={teacher} lang={lang}
						changeFromExisting={this.changeFromExisting} noTeacherUsers={noTeacherUsersByFranchisee}
						fromExisting={this.state.fromExisting} onSelectExistingUser={this.onSelectExistingUser}
					/>
				}
				<TeacherSettingsForm franchiseeId={franchiseeId} onSubmit={this.handleTeacherSettingsSubmit}
					initialValues={initialValues} isReadonly={isReadonly || this.state.fromExisting === true}
					hasSelectedUser={this.state.selectedUserId > 0} lang={lang}
				/>
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const teacherId = ownProps.match.params.teacherId;

	const {
		entities: { teachers, noTeacherUsers },
		filters: { noTeacherUsersByFranchisee },
		auth: { currentUser }
	} = state;
	const noTeacherUsersFilter = noTeacherUsersByFranchisee[ownProps.franchiseeId] || { ids: [] };

	return {
		teacher: teachers[teacherId],
		noTeacherUsersByFranchisee: noTeacherUsersFilter.ids ? noTeacherUsersFilter.ids.map(id => noTeacherUsers[id]) : [],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Franchisees'),
		noTeacherUsers,
		lang: getActiveLanguage(state.configuration.language),
	};
};

export default connect(mapStateToProps, {
	fetchTeacher,
	createTeacher,
	updateTeacher,
	createTeacherFromExistingUser,
	loadNoTeacherUsers
})(withTranslation()(Details));